import { SentimentTooltip } from "@/components/SentimentTooltip/SentimentTooltip";
import { SentimentValue } from "@/graphql/generated/graphql";
import { useSeekAndScroll } from "@/hooks/useSeekAndScroll/useSeekAndScroll";
import { useBaseStore } from "@/store/store";
import { PlayerSpeakerSegmentProps } from "./PlayerSpeakerSegment.decl";
import * as S from "./PlayerSpeakerSegment.styled";

function getSegmentBgColor(value: SentimentValue) {
  switch (value) {
    case "POSITIVE":
      return "graphic-success-strong";
    case "NEGATIVE":
      return "graphic-critical-strong";
    case "NEUTRAL":
      return "graphic-neutral";
    default:
      return "graphic-default";
  }
}

export function PlayerSpeakerSegment({
  startTime,
  left,
  width,
  color,
  index,
  call,
  onClick,
}: PlayerSpeakerSegmentProps) {
  const mode = useBaseStore((state) => state.mode);
  const { seekAndScroll } = useSeekAndScroll(startTime);

  const matches = useBaseStore((store) => store.searchContentMatches);

  const isHighlighted = !!matches?.get(index);
  const utteranceSentiments = call?.utteranceSentiments;

  const sentiment = utteranceSentiments?.get(index)?.value;
  const highlightedAttr = isHighlighted ? true : undefined;

  const channel = call?.transcription?.content?.utterances?.[index]?.channel;

  const handleOnClick = () => {
    // I think we should always get a channel at this point.
    if (!channel) {
      seekAndScroll();
      return;
    }

    seekAndScroll();
    onClick(index);
  };

  if (!sentiment || mode !== "sentiments") {
    return (
      <S.Segment
        key={startTime}
        left={left}
        width={width}
        bg={color}
        onClick={handleOnClick}
        data-test={`segment-${startTime}`}
        data-highlighted={highlightedAttr}
        isHighlighted={isHighlighted}
      />
    );
  }

  if (sentiment === "NEUTRAL") {
    return (
      <S.Segment
        key={startTime}
        left={left}
        width={width}
        bg={getSegmentBgColor(sentiment)}
        onClick={handleOnClick}
        data-test={`segment-${startTime}`}
        data-highlighted={highlightedAttr}
        isHighlighted={isHighlighted}
      />
    );
  }

  return (
    <SentimentTooltip value={sentiment}>
      <S.Segment
        key={startTime}
        left={left}
        width={width}
        bg={getSegmentBgColor(sentiment)}
        onClick={handleOnClick}
        data-test={`segment-${startTime}`}
        data-highlighted={highlightedAttr}
        isHighlighted={isHighlighted}
      />
    </SentimentTooltip>
  );
}
